/**
 * Componente que renderiza un selector (dropdown) para cambiar el estado de un ticket.
 * * Permite al usuario seleccionar una nueva "Etapa" de una lista predefinida de estados,
 * sincronizando el valor actual con la propiedad `statusId` del ticket.
 * Se muestra como una fila compacta clave → valor del panel de propiedades.
 * * @component
 * @param {Object} props - Propiedades del componente.
 * @param {Array<Object>} props.status - Lista de estados disponibles para el selector.
 * @param {number|string} props.status[].id - Identificador único del estado.
 * @param {string} props.status[].name - Nombre descriptivo del estado (ej: "Pendiente", "Resuelto").
 * @param {Object} props.ticket - Objeto que representa el ticket actual.
 * @param {number|string} props.ticket.statusId - El ID del estado actual asociado al ticket.
 * @param {Function} props.changeStatus - Función callback que se ejecuta al seleccionar un nuevo estado.
 * Recibe el nuevo ID convertido a `Number`.
 * * @returns {JSX.Element} Una fila con la etiqueta y el select de etapa.
 */
const TicketStatus = ({ status, ticket, changeStatus }) => {
  return (
    <div className="vt-prop">
      <label className="vt-prop-label" htmlFor="vt-ticket-status">
        Etapa
      </label>
      <select
        id="vt-ticket-status"
        className="form-select form-select-sm vt-prop-select"
        value={ticket.statusId}
        onChange={(e) => changeStatus(Number(e.target.value))}
      >
        {status.map((i) => (
          <option key={i.id} value={i.id}>
            {i.name}
          </option>
        ))}
      </select>
    </div>
  )
}

export default TicketStatus
